import { Link } from "react-router-dom";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_buildguard-preview/artifacts/3lbt7aob_nirmantra_ai_icon.png";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startLogin = (goto) => {
  if (goto) localStorage.setItem("bg_goto", goto);
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Footer() {
  const cols = [
    { title: "Product", links: [["How it works", "/#how"], ["Why Nirmantra", "/#why"], ["FAQ", "/#faq"]] },
    { title: "Company", links: [["About Us", "/about"], ["Stories", "/blog"], ["Contact", "/contact"], ["Become a Partner", "/vendor/register"]] },
    { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Terms & Conditions", "/terms"]] },
  ];
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2.5">
            <img src={LOGO} alt="Nirmantra.ai" className="h-10 w-10 rounded-xl object-cover" />
            <span className="font-display font-extrabold text-lg tracking-tight text-slate-900">Nirmantra<span className="text-[#0E9AC8]">.ai</span></span>
          </div>
          <p className="mt-4 font-display font-bold text-slate-800">Intelligence for every foundation.</p>
          <p className="mt-2 text-sm text-slate-500 leading-relaxed max-w-xs">
            India's AI-powered construction advisory platform — helping owners build with confidence and protect every rupee.
          </p>
          <a href="mailto:info@nirmantra.ai" className="mt-4 inline-block text-sm text-slate-600 hover:text-[#0E9AC8] transition-colors">info@nirmantra.ai</a>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{c.title}</p>
            <ul className="mt-4 space-y-3">
              {c.links.map(([label, href]) => (
                <li key={label}>
                  {href.startsWith("/#") ? (
                    <a href={href} className="text-sm text-slate-600 hover:text-[#0E9AC8] transition-colors">{label}</a>
                  ) : (
                    <Link to={href} className="text-sm text-slate-600 hover:text-[#0E9AC8] transition-colors">{label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-100">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-slate-400">© 2026 Nirmantra.ai. All rights reserved.</p>
          <p className="text-xs text-slate-400">Independent advisory — not a contractor or builder.</p>
        </div>
      </div>
    </footer>
  );
}
